import React from 'react';
import { graphql } from 'gatsby';
import { OmPillarCarousel } from '@om/component-library-react';
import RefinedPillarCard from '../components/RefinedPillarCard';

function createSlotName(index) {
    return `card-${index + 1}`;
}

function numberOfCards(om_carousel_slot) {
    return om_carousel_slot ? om_carousel_slot.length : 0;
}

function display_as_landscape_card() {
    return numberOfCards() === 1;
}

const PillarCarousel = ({
    pillarCarouselContent,

}) => {
    if (!pillarCarouselContent) {
        return '';
    }
    const {
        uid,
        has_boundary,
        top_line,
        heading,
        sub_title,
        caption,
        om_carousel_slot,
        is_extended_carousel
    } = pillarCarouselContent;

    return (
        <OmPillarCarousel
            id={uid}
            hasBoundary={has_boundary}
            numberOfCards={numberOfCards(om_carousel_slot)}
        >
            {
                top_line ?
                    <span slot="top-line" dangerouslySetInnerHTML={{ __html: top_line }} /> 
                    : ''

            }
            {
                heading ?
                    <h1 slot="heading" dangerouslySetInnerHTML={{ __html: heading }} />
                    : ''

            }
            {
                sub_title ?
                    <span slot="subtitle" dangerouslySetInnerHTML={{ __html: sub_title }} /> 
                    : ''

            }
            {
                caption ?
                    <span slot="caption" dangerouslySetInnerHTML={{ __html: caption }} /> 
                    : ''

            }
            {
                om_carousel_slot ? om_carousel_slot.map((card, index) => {
                    return (
                        <RefinedPillarCard
                            key={card.uid}
                            refinedPillarCardContent={card}
                            isLandscape={display_as_landscape_card()}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index)}
                        />
                    );
                }) : ''
            }
        </OmPillarCarousel>
    );
};

export const pageQuery = graphql`
fragment PillarCarousel on Contentstack_pillar_carousel {
    uid
    has_boundary
    top_line
    heading
    sub_title
    caption
    om_carousel_slot {
        ...RefinedPillarCard
    }
    is_extended_carousel
}
`;

export default PillarCarousel